(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2585],{

/***/ 32585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ layouts_SpecialOffersPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./containers/index.js + 35 modules
var containers = __webpack_require__(44420);
// EXTERNAL MODULE: ./utils/index.js + 3 modules
var utils = __webpack_require__(70214);
// EXTERNAL MODULE: ./seo/Mindbox.js
var Mindbox = __webpack_require__(22182);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./layouts/SpecialOffersPage/SpecialOffersPage.module.scss
var SpecialOffersPage_module = __webpack_require__(62906);
var SpecialOffersPage_module_default = /*#__PURE__*/__webpack_require__.n(SpecialOffersPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/SpecialOffersPage/SpecialOffersPage.js













var Pagination = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4436).then(__webpack_require__.bind(__webpack_require__, 64436));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Loader */.aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64436)];
    }
  }
});

var SpecialOffersPage = function SpecialOffersPage(_ref) {
  var articles = _ref.articles,
      meta = _ref.meta,
      seo = _ref.seo;
  var router = (0,next_router.useRouter)();
  var query = router.query;

  var _ref2 = meta || {},
      total = _ref2.total,
      per_page = _ref2.per_page,
      last_page = _ref2.last_page;

  var _qs$parse = lib_default().parse(query),
      _qs$parse$page = _qs$parse.page,
      page = _qs$parse$page === void 0 ? 1 : _qs$parse$page;

  var _getLinkProps = (0,getLinkProps/* default */.Z)({
    type: 'special-offers'
  }),
      _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 3),
      specialOffersHref = _getLinkProps2[0],
      _specialOffersAs = _getLinkProps2[1],
      specialOffersTitle = _getLinkProps2[2];

  var breadCrumbsSpecialOffers = [{
    slug: specialOffersHref,
    name: specialOffersTitle
  }];
  (0,react.useEffect)(function () {
    Mindbox/* default.viewPage */.ZP.viewPage({
      page: 'SpecialOffers'
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (SpecialOffersPage_module_default()).offersSection,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(containers/* Container */.W2, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SpecialOffersPage_module_default()).breadCrumbs,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* BreadCrumbs */.bu, {
          type: "news",
          breadcrumbs: breadCrumbsSpecialOffers
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(components/* Title */.Dx, {
        component: "h1",
        mb: "large",
        children: seo && seo.h1 ? (0,utils/* getCorrectName */.tx)(seo.h1) : 'Акции'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* SpecialOffers */.T7, {
        items: articles
      }), total > per_page && /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination, {
        lastPage: last_page,
        currentPage: page,
        shallow: false
      })]
    })
  });
};

/* harmony default export */ var SpecialOffersPage_SpecialOffersPage = (SpecialOffersPage);
;// CONCATENATED MODULE: ./layouts/SpecialOffersPage/index.js

/* harmony default export */ var layouts_SpecialOffersPage = (SpecialOffersPage_SpecialOffersPage);

/***/ }),

/***/ 62906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SpecialOffersPage_breadCrumbs__BbcqQ","offersSection":"SpecialOffersPage_offersSection__0ZSU4"};

/***/ })

}]);